import React from "react";
import { ShoppingCart } from "lucide-react";
import { Link } from "react-router-dom";
import { useCart } from "../context/CartContext";

const ProductCard = ({ product }) => {
  const { addToCart } = useCart();
  const BASE_URL = process.env.REACT_APP_API_IMAGE_URL;
  return (
    <div className="relative group rounded-2xl p-4 bg-gradient-to-br from-[#1f1f47] via-[#111132] to-[#0f1b2a] shadow-[0_0_20px_rgba(0,255,255,0.1)] border border-cyan-700/30 hover:shadow-cyan-400/30 transition-all duration-300 hover:scale-[1.03]">
      {/* Glowing edge */}
      <div className="absolute -inset-[2px] rounded-2xl bg-gradient-to-br from-cyan-500 via-transparent to-purple-600 blur-xl opacity-0 group-hover:opacity-60 transition duration-500 z-0" />

      {/* Image Box */}
      <div className="relative z-10 mb-4 aspect-square rounded-xl overflow-hidden border border-purple-600 bg-black/20">
        <Link to={`/product/${product.slug}`}>
          <img
            src={`${BASE_URL}${product.image[0]}`}
            alt={product.name}
            className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
          />
        </Link>
      </div>

      {/* Product Content */}
  
        <div className="relative z-10 text-white space-y-1">
            <Link to={`/product/${product.slug}`}>
          <h3 className="text-lg font-semibold truncate">{product.name}</h3>
          <p className="text-purple-400 text-sm font-bold">
            {product.category}
          </p>
          <p className="text-xl font-bold bg-clip-text text-white bg-gradient-to-r from-cyan-400 to-purple-500">
            ₹{product.price.toLocaleString()}
          </p>
          </Link>
        </div>
      

      {/* Add to Cart Button */}
      <button
        onClick={() => addToCart(product)}
        className="mt-4 w-full flex items-center justify-center gap-2 bg-gradient-to-r from-cyan-500 to-purple-600 text-white font-semibold py-2 rounded-xl transition-all duration-300 group hover:from-purple-600 hover:to-cyan-500 hover:shadow-xl hover:shadow-purple-500/40"
      >
        <ShoppingCart size={18} />
        <span className="group-hover:scale-105 transition-transform duration-300">
          Add to Cart
        </span>
      </button>

      {/* View Details Button */}
      {/* <Link to={`/product/${product.slug}`}>
        <button className="mt-2 w-full flex items-center justify-center gap-2 border border-cyan-400 text-cyan-300 font-medium py-2 rounded-xl transition-all duration-300 group hover:bg-cyan-800/30 hover:border-cyan-500 hover:text-white hover:shadow-md hover:shadow-cyan-400/40">
          <span className="group-hover:scale-105 transition-transform duration-300">View Details</span>
        </button>
      </Link> */}
    </div>
  );
};

export default ProductCard;
